import styles from "./index.module.css";
import { use, useState } from "react";
import Input from "../../../Components/FormComponents/Input";
import InputPhone from "../../../Components/FormComponents/PhoneInput";
import FakeButton from "../../../Components/FormComponents/FakeButton";
import UserContext from "../../../store/UserStore/context";
import { isPhoneValid } from "../../../Components/FormComponents/PhoneInput/validate";

const timeOptions = [10, 20];

export function DataForm({ onContinue }) {
  const userStore = use(UserContext);
  const [name, setName] = useState("");
  const [phoneNumber, setPhone] = useState("");
  const [tgUsername, setTgUsername] = useState("");
  const [time, setTime] = useState(20);
  const [error, setError] = useState("");

  const filledIn = name.trim() && phoneNumber && tgUsername.trim() && time;

  function handleContinue() {
    if (!filledIn) {
      setError("Заповни всі поля, щоб продовжити.");
      return;
    }

    // The field shows its own error on blur, but an incomplete number the
    // user never blurred out of would otherwise reach the payment stage.
    if (!isPhoneValid(phoneNumber)) {
      setError("Введи коректний номер телефону.");
      return;
    }

    const normalizedPhone = phoneNumber.trim().replace(/^\+/, "");

    setError("");
    onContinue({
      email: userStore.store.user?.email,
      name: name.trim(),
      phoneNumber: `+${normalizedPhone}`,
      tgUsername: tgUsername.trim(),
      time,
    });
  }

  return (
    <div className={styles.container}>
      <h1>Записатись на інтенсив</h1>

      <div className={styles.fields}>
        <Input
          value={name}
          onChange={setName}
          className={styles.field}
          placeholder={"John Doe"}
          label={"Ім'я"}
          required
        />
        <InputPhone
          value={phoneNumber}
          onChange={setPhone}
          className={styles.field}
          placeholder={"00 000 00 00"}
          label={"Номер телефону"}
          type={"tel"}
          required
        />
        <Input
          value={tgUsername}
          onChange={setTgUsername}
          className={styles.field}
          placeholder={"@johndoe"}
          label={"Нікнейм у Telegram"}
          required
        />

        <div className={styles.field}>
          <div className={styles.timeLabel}>Час</div>
          <div className={styles.timeOptions}>
            {timeOptions.map((option) => (
              <button
                key={option}
                type="button"
                className={[
                  styles.timeOption,
                  time === option ? styles.activeTimeOption : "",
                ].join(" ")}
                onClick={() => setTime(option)}
              >
                {option}:00
              </button>
            ))}
          </div>
        </div>
      </div>

      {error ? <div className={styles.error}>{error}</div> : null}

      <div className={styles.button}>
        <FakeButton onClick={handleContinue}>Продовжити</FakeButton>
      </div>

      <div className={styles.privacy}>
        Натискаючи «Продовжити», ти приймаєш{" "}
        <a href={"/contract-offer"} target={"_blank"} rel="noreferrer">
          угоду
        </a>
      </div>
    </div>
  );
}
